import { Component, OnInit, ViewChild } from '@angular/core';
import { CajaService } from 'src/app/service/index.service';
import { Caja } from 'src/app/model/index.model';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { FilCajaComponent } from '../../filtro/fil-caja/fil-caja.component';

@Component({
  selector: 'app-reporte-caja',
  templateUrl: './reporte-caja.component.html',
  styleUrls: ['./reporte-caja.component.css']
})
export class ReporteCajaComponent implements OnInit {
  @ViewChild(FilCajaComponent, { static: true }) fil: FilCajaComponent;
  entity = "Cajas"

  items: Caja[];
  item: Caja;
  fecha = new Date();

  loading: boolean = false;
  constructor(private wsdl: CajaService) {
    this.items = []
  }

  ngOnInit() {
    this.loading = true
    this.fil.list();

  }
  get cajasAbiertas(): number {
    return this.items?.filter(item => item.isOpen == true).length || 0;
  }

  get totalCajas(): number {
    return this.items?.length || 0;
  }
  select(item: Caja) {
    this.item = item;
  }

  doFound(event: Caja[]) {
    this.items = event;
    this.loading = false
  }

  cancel() {
    this.item = new Caja();
    this.fil.list();
  }

  async setResultCancel(event: boolean) {
    UturuncoUtils.showToas("Operación cancelada", "info");
  }

  setResult(event: any) {
    this.cancel();
  }

  exportTableToExcel(tableID: string, filename = 'excel_data.xlsx') {
    const dataType = 'application/vnd.ms-excel';

    const tableSelect = document.getElementById(tableID);
    if (!tableSelect) {
      console.error(`Tabla con ID '${tableID}' no encontrada`);
      return;
    }

    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Crear nombre de archivo
    filename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;

    const nav = window.navigator as any;

    if (nav && typeof nav.msSaveOrOpenBlob === 'function') {
      // IE11 o Edge Legacy
      const blob = new Blob(['\ufeff', tableHTML], { type: dataType });
      nav.msSaveOrOpenBlob(blob, filename);
    } else {
      // Navegadores modernos
      const downloadLink = document.createElement("a");
      downloadLink.href = `data:${dataType},${tableHTML}`;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }


}
